import { CSSProperties, cx } from '@linaria/core';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { openMenuDialog } from '../../actions/menu';
import { AppStateType, EventType } from '../../constants/enums';
import { avatarUrl } from '../../mfcLogic/avatarPreviewUrl';
import { updateAppState } from '../../state/state.app';
import { motionTransition } from '../../utilities/transitions';
import { Slide } from '../common/transitions';
import { useModelColor } from '../Hooks/useModelColor';
import { useScreenStateSelector } from '../Hooks/useScreenState';
import { useUserSelector } from '../Hooks/useUser';
import { COMPONENT_HEIGHTS, COMPONENT_WIDTHS } from '../theme';
import "./Featured.linaria.module.css!=!./Featured?./Featured.linaria.module.css?css=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"
const stylesPolaroidContainer = "atm_uc_sw4msw atm_fc_1y6m0gg atm_ar_vrvcex atm_mk_stnw88 atm_wq_wbg9ig atm_9s_1txwivl atm_6i_5b8oim atm_lo_exct8b atm_le_exct8b atm_lk_exct8b atm_ll_exct8b atm_e2_1qwj45i atm_fq_1ssbidh atm_vy_1kijqam atm_gz_17bs3n4";
const stylesPolaroidContainerMobile = "atm_gz_idpfg4 atm_vy_1osqo2v atm_6i_9by0np atm_e2_1w81w6r atm_fq_f1ugbe";
const stylesPolaroidContainerMobileLandscape = "atm_gz_17t3fkc atm_6i_c18wl4 atm_fq_1ssbidh atm_vy_1qy09so";
const stylesPolaroidContainerTablet = "atm_gz_81i08u atm_6i_16gx6hh atm_e2_1wdtr47 atm_fq_1ssbidh atm_vy_oza482";
const stylesPolaroidContainerCompact = "atm_wq_15ggnzb atm_gz_idpfg4 atm_e2_kz1e7l atm_vy_l09piu atm_lo_idpfg4 atm_le_idpfg4 atm_lk_idpfg4 atm_ll_idpfg4 atm_6i_voey9q atm_fq_17svt4j";
const stylesPolaroidContainerCompactMobile = "atm_2d_1wj0jbo atm_fc_1b1vv5m atm_vy_1osqo2v atm_e2_ucftp2 atm_fq_idpfg4";
const stylesPolaroidContainerCompactMobileLandscape = "atm_6i_zt4szt";
const stylesPolaroid = "atm_uc_qqj2os atm_70_1wncenj atm_2d_di95bc atm_n4_1czdvr2 atm_r3_1h6ojuz atm_h0_t94yts atm_5j_idpfg4 atm_7l_1d6myej atm_e2_gx0z50 atm_vy_3ltk1 atm_lo_ftgil2 atm_le_ftgil2 atm_lk_ftgil2 atm_ll_ftgil2 atm_nf_kb7nvz";
const stylesPolaroidMobile = "atm_e2_1ygari0 atm_lo_i2wt44 atm_le_i2wt44 atm_lk_i2wt44 atm_ll_i2wt44 atm_vy_18lybw4";
const stylesPolaroidTablet = "atm_e2_13loom1 atm_vy_plmocm";
const stylesPolaroidCompact = "atm_70_j56bdf atm_2d_nznn1u atm_7l_ivydl7 atm_5j_ftgil2 atm_9j_tlke0l atm_e2_kz1e7l atm_vy_h176v8 atm_13ygtfo_10wamp9";
const stylesPolaroidCompactMobile = "atm_h0_idpfg4 atm_e2_pk3tuj atm_lo_idpfg4 atm_le_idpfg4 atm_lk_idpfg4 atm_ll_idpfg4";
const stylesPolaroidIMG = "atm_uc_ion19i atm_70_j56bdf atm_3f_1iyo7vl atm_5j_idpfg4 atm_e2_15o9syp atm_vy_15o9syp";
const stylesPolaroidIMGCompact = "atm_70_1wncenj atm_3f_1q1r3o3 atm_5j_1osqo2v atm_e2_rw9lz9 atm_vy_rw9lz9";
const stylesPolaroidIMGMobile = "atm_e2_pk3tuj atm_vy_pk3tuj";
const stylesPolaroidIMGTablet = "atm_e2_11ux3fc atm_vy_11ux3fc";
const stylesPolaroidIMGCompactMobile = "atm_e2_1fwpi09 atm_vy_1fwpi09";
const stylesPolaroidText = "atm_uc_1ehiwpo atm_2d_nznn1u atm_sy_1uof6cm atm_3f_1iyo7vl atm_r3_1h6ojuz atm_cs_ni7l0g atm_5j_yh40bf atm_lo_idpfg4 atm_le_idpfg4 atm_lk_idpfg4 atm_ll_idpfg4";
const stylesPolaroidTextMobile = "atm_h3_myb0kj";
const stylesPolaroidTextCompact = "atm_2d_o65fvd atm_sy_1vrl6hi atm_3f_1q1r3o3 atm_lo_yh40bf atm_le_yh40bf atm_lk_yh40bf atm_ll_yh40bf";
const stylesPolaroidTextCompactMobile = "atm_lo_t94yts atm_le_t94yts atm_lk_t94yts atm_ll_t94yts atm_h3_12gsa0d";
const stylesPolaroidRank = "atm_gq_t94yts atm_c8_dlk8xv";
const stylesPolaroidRankCompact = "atm_c8_rdoju8";
const stylesPolaroidRankMobile = "atm_c8_ftgil2";
const stylesPolaroidRankTablet = "atm_c8_1skhajo";
const stylesPolaroidRankCompactMobile = "atm_c8_1ebrlns";
const stylesPolaroidSubName = "atm_c8_1q7vzsg";
const stylesPolaroidSubNameMobile = "atm_c8_1ebrlns atm_h3_myb0kj";
const stylesPolaroidSubNameCompact = "atm_c8_rdoju8";
const stylesPolaroidSubNameCompactMobile = "atm_c8_1ebrlns atm_h3_12gsa0d";
const imageUrlToBase64 = async (id, isMobile) => {
  const url = avatarUrl(id, isMobile ? 150 : 300); //`/static/models/${id}.webp`
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
    reader.onerror = reject;
  });
};
const rankLabel = rank => {
  if (rank <= 3) {
    return 'Top 3!';
  }
  if (rank <= 10) {
    return 'Top 10!';
  }
  if (rank <= 20) {
    return 'Top 20!';
  }
  if (rank <= 100) {
    return 'Top 100';
  }
  if (rank <= 250) {
    return 'Top 250';
  }
  if (rank <= 500) {
    return 'Top 500';
  }
  return 'Top 1000';
};
const Polaroid = props => {
  const {
    isMobileLandscape,
    isTablet,
    username,
    isMobile,
    compact,
    rotate,
    rank,
    src,
    id
  } = props;
  const onClickCallback = useCallback(() => {
    motionTransition(() => openMenuDialog(id), {
      id
    });
  }, [id]);
  const modelColor = useUserSelector(id, 'color');
  const color = useModelColor(modelColor);
  return <div onClick={onClickCallback} className={cx(stylesPolaroid, (isMobile || isMobileLandscape) && stylesPolaroidMobile, isTablet && stylesPolaroidTablet, compact && stylesPolaroidCompact, compact && isMobile && stylesPolaroidCompactMobile)} style={compact ? null : {
    '--rotate': rotate
  } as CSSProperties}>
            <img alt={username} src={src} className={cx(stylesPolaroidIMG, (isMobile || isMobileLandscape) && stylesPolaroidIMGMobile, isTablet && stylesPolaroidIMGTablet, compact && stylesPolaroidIMGCompact, compact && isMobile && stylesPolaroidIMGCompactMobile)} />
            <div className={cx(stylesPolaroidText, (isMobile || isMobileLandscape) && stylesPolaroidTextMobile, compact && stylesPolaroidTextCompact, compact && isMobile && stylesPolaroidTextCompactMobile)}>
                <div className={cx(stylesPolaroidRank, (isMobile || isMobileLandscape) && stylesPolaroidRankMobile, isTablet && stylesPolaroidRankTablet, compact && stylesPolaroidRankCompact, compact && isMobile && stylesPolaroidRankCompactMobile)}>
                    Miss MFC {rankLabel(rank)}
                </div>
                <div data-testid="FeaturedModel__Username" style={{
        color
      }} className={cx(stylesPolaroidSubName, (isMobile || isMobileLandscape) && stylesPolaroidSubNameMobile, compact && stylesPolaroidSubNameCompact, compact && compact && isMobile && stylesPolaroidSubNameCompactMobile)}>
                    {username}
                </div>
            </div>
        </div>;
};
interface FeaturedProps {
  isMobileLandscape: boolean;
  leftNavExpanded: boolean;
  showBottomNav: boolean;
  showLeftNav: boolean;
  isMobile: boolean;
  isLoaded: boolean;
}
const Featured = (props: FeaturedProps) => {
  const {
    isMobile: _isMobile,
    isMobileLandscape,
    leftNavExpanded,
    showBottomNav,
    showLeftNav,
    isLoaded
  } = props;
  const portrait = useScreenStateSelector('portrait');
  const windowWidth = useScreenStateSelector('windowWidth');
  const windowHeight = useScreenStateSelector('windowHeight');
  const [featured1, setFeatured1] = useState(null);
  const [featured2, setFeatured2] = useState(null);
  const [featured3, setFeatured3] = useState(null);
  // true when the grid had already painted (seeded boot) by the time the
  // first image arrived: there is no loading screen to play the full-size
  // intro over, so the polaroids go straight to the compact corner
  const [skipIntro, setSkipIntro] = useState(false);
  const isLoadedRef = useRef(isLoaded);
  useEffect(() => {
    isLoadedRef.current = isLoaded;
  }, [isLoaded]);

  // full-size until the loading screen is gone AND all three images are
  // in, so the container and the polaroids always shrink together; with
  // the intro skipped they mount compact and never transition
  const compact = isLoaded && (skipIntro || !!featured3);
  const isMobile = _isMobile && portrait && windowWidth < 600;
  const isTabletHeight = !compact && !isMobile && windowHeight >= 610 && windowHeight < 920;
  const isMobileLandscapeLayout = isMobileLandscape || !compact && windowHeight < 610;

  // account for nav (compact mode)
  const compactPosition = useMemo(() => {
    if (!compact) return {}; // not compacted yet

    const leftOffset = showLeftNav ? (leftNavExpanded ? COMPONENT_WIDTHS.leftNavExpanded : COMPONENT_WIDTHS.leftNav) + 8 : 8;
    const bottomOffset = showBottomNav ? `calc(var(--saib) + ${COMPONENT_HEIGHTS.navBottom}px)` : '0px';
    return {
      '--compact-left': `${leftOffset}px`,
      '--compact-bottom': bottomOffset
    } as CSSProperties;
  }, [compact, showLeftNav, showBottomNav, leftNavExpanded]);
  useEffect(() => {
    const featured = window.__MFC_SERVER_SIDE_STATE__.find(state => {
      if (typeof state !== 'object') {
        return false;
      }
      const {
        type
      } = state;
      return type === EventType.SERVER_SIDE_FEATURED_MODELS;
    });
    if (!featured) {
      updateAppState(AppStateType.APP, {
        hideFeaturedModels: true
      });
      return;
    }
    const {
      data
    } = featured;
    if (!Array.isArray(data)) {
      return;
    }
    const [f1, f2, f3] = data;
    imageUrlToBase64(f1.id, isMobile).then(base64Image => {
      setSkipIntro(isLoadedRef.current);
      setFeatured1({
        src: base64Image,
        ...f1
      });
      return imageUrlToBase64(f2.id, isMobile);
    }).then(base64Image => {
      setFeatured2({
        src: base64Image,
        ...f2
      });
      return imageUrlToBase64(f3.id, isMobile);
    }).then(base64Image => {
      setFeatured3({
        src: base64Image,
        ...f3
      });
    }).catch(_ => _);
  }, [isMobile]);
  if (!featured1) {
    return null;
  }
  return <div data-testid="Container__FeaturedModels" className={cx(stylesPolaroidContainer, (isMobile || isMobileLandscapeLayout) && stylesPolaroidContainerMobile, isMobileLandscapeLayout && stylesPolaroidContainerMobileLandscape, isTabletHeight && stylesPolaroidContainerTablet, compact && stylesPolaroidContainerCompact, compact && isMobile && stylesPolaroidContainerCompactMobile, compact && isMobileLandscape && stylesPolaroidContainerCompactMobileLandscape)} style={compact ? compactPosition : {}}>
            <Slide in direction="right" appear={!skipIntro}>
                <div data-testid="FeaturedModels__Container__1">
                    <Polaroid {...featured1} compact={compact} isMobileLandscape={isMobileLandscapeLayout} isTablet={isTabletHeight} isMobile={isMobile} rotate="10deg" />
                </div>
            </Slide>
            {featured2 && <Slide in direction="up" appear={!skipIntro}>
                    <div data-testid="FeaturedModels__Container__2">
                        <Polaroid {...featured2} isMobileLandscape={isMobileLandscapeLayout} isTablet={isTabletHeight} compact={compact} isMobile={isMobile} rotate="-10deg" />
                    </div>
                </Slide>}
            {featured3 && <Slide in direction="left" appear={!skipIntro}>
                    <div data-testid="FeaturedModels__Container__3">
                        <Polaroid {...featured3} isMobileLandscape={isMobileLandscapeLayout} isTablet={isTabletHeight} isMobile={isMobile} compact={compact} rotate="5deg" />
                    </div>
                </Slide>}
        </div>;
};
export default Featured;